module.exports = __webpack_public_path__ + "static/media/10.3b2e7977.png";